import Password from '../components/Registration/Password'
import Edit from '../components/Registration/Edit'
import AddArtist from '../components/Registration/AddArtist'

export default [
  {
    path: '/client/registration/password',
    name: 'password',
    component: Password,
  },
  {
    path: '/client/registration/edit',
    name: 'edit',
    component: Edit,
  },
  {
    path: '/client/registration/add-artist',
    name: 'add-artist',
    component: AddArtist,
  },
]
